var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"m-the-modal-shadow",on:{"click":function($event){$event.preventDefault();return _vm.$modal.closeModal($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }